import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useAccordion } from './AccordionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AccordionContent(_ref) {
  var children = _ref.children;

  var _useAccordion = useAccordion(),
      isExpanded = _useAccordion.isExpanded;

  var _useState = useState(0),
      height = _useState[0],
      setHeight = _useState[1];

  var ref = useRef(null);
  useEffect(function () {
    var _ref$current;

    setHeight(ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientHeight);
  }, [ref, isExpanded, children]);
  return /*#__PURE__*/_jsx("div", {
    className: clsx("transition-height overflow-hidden duration-300", isExpanded ? 'display-block' : 'display-none'),
    style: {
      height: "".concat(isExpanded ? height : 0, "px")
    },
    children: /*#__PURE__*/_jsx("div", {
      ref: ref,
      className: clsx('box-border px-10 pt-6 pb-10 transition-opacity duration-300', isExpanded ? 'opacity-100' : 'opacity-0'),
      children: children
    })
  });
}